export default {
    preferences: state => state.preferences,
    deviceRecentlySeen: state => state.deviceRecentlySeen,
}